export default __webpack_public_path__ + "static/media/040-dog.860cdcd6.png";